<script>
import { getCurrencyAccoringTolanguage, getErrorMessageByErrorCode, getCreditsAccoringTolanguage, getDateAccoringTolanguage } from "@/shared/util/helpers.js";
import { EventBus } from "@/shared/util/event-bus.js";
import CreditPlanService from '@/api/services/creditPlan.service.js';
import CreditPlanStatus from '@/shared/enums/creditPlanStatus.js';
import CreditPlanTypes from '@/shared/enums/creditPlanTypes.js';
export default {
  props: {
    organization: Object
  },
  data() {
    return {
      /***** Data variables *****/
      creditPlans: null,
      dataForTable: null,
      showAllActiveCreditPlans: true,
      showAllExpiredCreditPlans: true,
      showAllUpcomingCreditPlans: true,
      creditPlanStausEnum: CreditPlanStatus,
      nextAvailableCreditPlanForCompany: null,
      /****** Operational variable ******/
      isComponentLoading: false,
      isFetchingDataError: false,
      dataFetchingnErrorMessage: null,
      /***** Table Data *****/
      fieldsForTable: [
        {
          key: "isRunning",
          label: "",
          thStyle: { width: "40px" }
        },
        { 
          key: "id",
          label: "ID",
          thClass: "d-none",
          tdClass: "d-none"
        },
        {
          key: "date",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.date"),
        },
        {
          key: "name",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.name")
        },
        {
          key: "type",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.type"),
          thClass: "d-none",
          tdClass: "d-none"
        },
        {
          key: "status",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.status"),
        },
        {
          key: "startDate",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.startDate"),
        },
        {
          key: "expirationDate",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.expireDate"),
        },
        {
          key: "balance",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.balance"),
        },
        {
          key: "received",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.receive"),
        },
        {
          key: "pricePerCredit",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.pricePerCredit"),
        },
        {
          key: "invoice",
          label: this.$t("adminComponents.creditPlansWidget.tableHeaders.invoice"),
        },
      ],
      currentPage: 1,
      perPage: 8
      ,
      filter: null
    }
  },
  computed: {
    rows() {
      return this.creditPlans.length;
    },
  },
  async mounted() {
    this.isComponentLoading = true;
    await this.fetchCreditPlans();
    this.isComponentLoading = false;
    EventBus.$emit("creditPlansComponetGetLoaded");
  },
  methods: {
    async fetchCreditPlans() {
      try {
        this.creditPlans = null;

        this.creditPlans = await CreditPlanService.getCompanyCreditPlansByType(this.organization.id, CreditPlanTypes.SECONDARY);
        await this.fetchNextAvailableCreditPlanForCompany();
        await this.setDataForTable();
      } catch(error) {
        this.isFetchingDataError = true;
        this.dataFetchingnErrorMessage = await getErrorMessageByErrorCode(error.code);
      }
    },
    setDataForTable(){
      this.dataForTable = []

      this.creditPlans.forEach(creditPlan => {
        let creditPlanToPush = {
          id: creditPlan.id,
          name: creditPlan.name,
          date: creditPlan.createdAt,
          type: creditPlan.type,
          status: creditPlan.status,
          startDate: creditPlan.startDate,
          expirationDate: creditPlan.expirationDate,
          balance: creditPlan.credits.balance,
          received: creditPlan.credits.received,
          pricePerCredit: creditPlan.pricePerCredit,
          isPayPerUsage: creditPlan.isPayPerUsage,
          isExpiring: creditPlan.isExpiring,
          invoice: creditPlan.invoice.number
        }

        if(creditPlanToPush.status === CreditPlanStatus.ACTIVE && this.showAllActiveCreditPlans) {
          this.dataForTable.push(creditPlanToPush)
        }

        if(creditPlanToPush.status === CreditPlanStatus.EXPIRED && this.showAllExpiredCreditPlans) {
          this.dataForTable.push(creditPlanToPush)
        }

        if(creditPlanToPush.status === CreditPlanStatus.UPCOMING && this.showAllUpcomingCreditPlans) {
          this.dataForTable.push(creditPlanToPush)
        }
      });
    },
    formatCredit(numberToFormat) {
      const langaugeToFormat = window.localStorage.getItem("locale");
      return getCreditsAccoringTolanguage(numberToFormat, langaugeToFormat);
    },
    formatDate(dateToFormat) {
      const langaugeToFormat = window.localStorage.getItem("locale");
      return getDateAccoringTolanguage(dateToFormat, langaugeToFormat);
    },
    formatCurrency(numberToFormat) {
      const langaugeToFormat = window.localStorage.getItem("locale");
      return getCurrencyAccoringTolanguage(numberToFormat, langaugeToFormat);
    },
    async fetchNextAvailableCreditPlanForCompany() {
      try {
        this.nextAvailableCreditPlanForCompany = null;
        this.nextAvailableCreditPlanForCompany = await CreditPlanService.getNextAvailableCreditPlanForCompany(this.organization.id);
      } catch(error) {
        this.isFetchingDataError = true;
        this.dataFetchingnErrorMessage = await getErrorMessageByErrorCode(error.code);
      }
    }
  }
}
</script>

<template>
  <div class="card" style="height:610px">
    <!-- Component Loading -->
    <div class="card-body" v-if="isComponentLoading">
      <div class="card-text">
        <div class="row pt-5">
          <div class="col-md-12 text-center p-5">
            <b-spinner
              style="width: 5rem; height: 5rem"
              class="m-2"
              variant="mid"
              role="status"
            ></b-spinner>
          </div>
        </div>
      </div>
    </div>

    <!-- Display Data -->
    <div class="card-body" v-if="!isComponentLoading && this.creditPlans && this.creditPlans.length > 0">
      <div class="card-text">
        
        <div class="row">
          <div class="col-12">
            <span style="font-size: medium; font-weight: 600"> {{$t("adminComponents.creditPlansWidget.title")}} </span>
          </div>
        </div>

        <!-- Search Bar & Fliters -->
        <div class="row mt-4">
          <div class="col-3">
            <b-form-input v-model="filter" type="search" :placeholder="$t('adminComponents.creditPlansWidget.searchPlaceholder')" ></b-form-input>
          </div>
          <div class="col-9 text-right">
            <b-form-checkbox
              v-model="showAllActiveCreditPlans"
              @change="setDataForTable"
              style="display: inline-block; margin-right: 10px; text-align: right;"
            >
              {{$t("adminComponents.creditPlansWidget.creditPlanStatus.active")}}
            </b-form-checkbox>

            <b-form-checkbox
              v-model="showAllExpiredCreditPlans"
              @change="setDataForTable"
              style="display: inline-block; margin-right: 10px; text-align: right;"
            >
              {{$t("adminComponents.creditPlansWidget.creditPlanStatus.expired")}}
            </b-form-checkbox>

            <b-form-checkbox
              v-model="showAllUpcomingCreditPlans"
              @change="setDataForTable"
              style="display: inline-block; margin-right: 10px; text-align: right;"
            >
              {{$t("adminComponents.creditPlansWidget.creditPlanStatus.upcoming")}}
            </b-form-checkbox>
          </div>
        </div>


        <!-- Data Table -->
        <div class="mt-4">
          <div class="table-responsive mb-0">
            <b-table
              :items="dataForTable"
              :fields="fieldsForTable"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :bordered="true"
              :filter="filter"
              :filter-included-fields="['description']"
            >

              <!-- Is Running Column -->
              <template v-slot:cell(isRunning)="scope">
                <i class="bx bxs-circle bx-flashing text-success" v-if="scope.item.id === nextAvailableCreditPlanForCompany?.id" ></i>
              </template>

              <!-- Date Column -->
              <template v-slot:cell(date)="data">
                {{ formatDate(data.value) }}
              </template>

              <!-- Balance Column -->
              <template v-slot:cell(balance)="scope">
                <span v-if="scope.item.isPayPerUsage">
                  <b-badge class="font-size-12" variant="blue2" pill>
                    {{$t("adminComponents.creditPlansWidget.payAsUsage")}}
                  </b-badge>
                </span>
                <span v-else> {{ formatCredit(scope.item.balance) }} </span>
              </template>

              <!-- Received Column -->
              <template v-slot:cell(received)="data">
                {{ formatCredit(data.value) }}
              </template>

              <!-- Status -->
              <template v-slot:cell(status)="data">
                <span
                  class="badge badge-soft-secondary font-size-12"
                  :class="{
                    'badge-soft-success': `${data.value}` === creditPlanStausEnum.ACTIVE,
                    'badge-soft-danger': `${data.value}` === creditPlanStausEnum.EXPIRED,
                    'badge-soft-warning': `${data.value}` === creditPlanStausEnum.UPCOMING
                  }"
                >
                  <span v-if="data.value === creditPlanStausEnum.ACTIVE"> {{$t("adminComponents.creditPlansWidget.creditPlanStatus.active")}} </span>
                  <span v-if="data.value === creditPlanStausEnum.EXPIRED"> {{$t("adminComponents.creditPlansWidget.creditPlanStatus.expired")}} </span>
                  <span v-if="data.value === creditPlanStausEnum.UPCOMING"> {{$t("adminComponents.creditPlansWidget.creditPlanStatus.upcoming")}} </span>
                </span>
              </template>

              <!-- Start Date -->
              <template v-slot:cell(startDate)="data">
                {{ formatDate(data.value) }}
              </template>

              <!-- Expiration Date -->
              <template v-slot:cell(expirationDate)="scope">
                {{ scope.item.isExpiring ? formatDate(scope.item.expirationDate) : "-" }}
              </template>

              <!-- Price Per Credit -->
              <template v-slot:cell(pricePerCredit)="data">
                <span v-if="data.value > 0">
                  {{ formatCurrency(data.value) }}
                </span>
                <span v-else>-</span>
              </template>

              <!-- Invoice -->
              <template v-slot:cell(invoice)="data">
                {{ data.value ? data.value : "-" }}
              </template>
            </b-table>
        </div>
        </div>

        <!-- pagination -->
        <div class="row">
          <div class="col">
            <div
              class="
                dataTables_paginate
                paging_simple_numbers
                float-right
              "
            >
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Display Empty Credit Plans Message -->
    <div class="card-body" v-if="!isComponentLoading && (!this.creditPlans || this.creditPlans.length === 0)">
      <div class="card-text">
        <div class="row">
          <div class="col-12 text-center pt-5">
            <img src="@/assets/images/information.png" class="img-fluid mb-4 mt-3" style="width: 60px" />
            <h6>
              {{$t("adminComponents.creditPlansWidget.noCreditPlansToDisplay.title")}}
            </h6>
            <p>
              {{$t("adminComponents.creditPlansWidget.noCreditPlansToDisplay.text1")}}<br/>
              {{$t("adminComponents.creditPlansWidget.noCreditPlansToDisplay.text2")}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>